import styled, { css } from 'styled-components'

const designerCSS = css`
  details summary h1 {
    font-size: 0.8rem;
    text-transform: uppercase;
    font-weight: 600;
    align-items: center;
    justify-content: flex-start;
    flex-flow: row;
    display: flex;
    margin: 1px 0 0 0;
    padding: 0 0 0 25px;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
  }

  details summary h1.panelClosed {
    width: 25%;
  }

  details summary h1 .icon {
    background: rgb(255, 255, 255);
    width: 16px;
    height: 16px;
    position: absolute;
    left: 20px;
    z-index: 1;
  }
  details summary h1 .icon.masked {
    mask: url(${({ icon }) => icon.path}) center center / 100% 100% no-repeat;
    background: ${({ icon }) => icon.color || '#fff'};
  }
  details summary h1 .icon {
    background: url(${({ icon }) => icon.path}) center center / 100% 100% no-repeat;
  }
  details summary h1 .icon {
    width: 16px;
    height: 16px;
    left: 15px;
  }
  details summary h1.panelClosed .icon {
    width: 24px;
    height: 24px;
    left: 32px;
  }
`

const developerCSS = css``

export const PanelSectionCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
